import React from 'react';
import PreLoginPage from './../core/PreLoginPage';

export default class TestComplete extends PreLoginPage{
	
	render(){
		return (

			<div className="errorContainer">
			<div className="errorback text-center">
			<div className="fff">
			<div id="temp_test_complete"><span className="f40 fwb">
			Test Complete! This is a temporary page.</span>
			</div>
			</div>
			</div>
			</div>

			)
		}

	}


// WEBPACK FOOTER //
// ./src/views/temp/TestComplete.js